define.alias("shared/modifiers/autoresize", "media/modifiers/autoresize");